import React, { FC, useCallback, useState } from 'react'
import styles from 'styles/components/calendar.module.scss'
import {
  IndividualScheduleCalendar,
  IndividualScheduleLabel,
  IndividualScheduleArrowButton,
  IndividualScheduleCaution,
} from 'components/Calendar'
import { Spacer } from 'components/Utility'
import { DayOfWeekType } from 'lib/daysOfWeek'

type Props = {
  activeDates: Date[]
  businessDays: DayOfWeekType[]
  currentMonth: Date
  handleCurrentMonth: (date: Date) => void
  individualSettingDates: Date[]
  selectSettingDate: (date: Date) => void
}

const IndividualScheduleCalendarContainer: FC<Props> = (props) => {
  const { activeDates, businessDays, currentMonth, handleCurrentMonth, individualSettingDates, selectSettingDate } =
    props

  const [isCaution, setCaution] = useState<boolean>(false)
  const handleCaution = useCallback((flag: boolean) => setCaution(flag), [setCaution])

  return (
    <div>
      <div className={styles.calendar__monthly__header}>
        <IndividualScheduleArrowButton
          currentMonth={currentMonth}
          handleCurrentMonth={handleCurrentMonth}
          label={'前月'}
          type={'prev'}
        />
        <IndividualScheduleLabel currentMonth={currentMonth} />
        <IndividualScheduleArrowButton
          currentMonth={currentMonth}
          handleCurrentMonth={handleCurrentMonth}
          label={'翌月'}
          type={'next'}
        />
      </div>
      <Spacer size={16} />
      <IndividualScheduleCalendar
        activeDates={activeDates}
        businessDays={businessDays}
        currentMonth={currentMonth}
        individualSettingDates={individualSettingDates}
        selectSettingDate={selectSettingDate}
        handleCaution={handleCaution}
      />
      {isCaution && (
        <>
          <Spacer size={16} />
          <IndividualScheduleCaution />
        </>
      )}
    </div>
  )
}

export default IndividualScheduleCalendarContainer
